<template lang="pug">
  .smallintroNav
    .smallintro
      .name(@click="selected=!selected") {{ name }}
      .intotri(:class="{triopen: selected==true}" @click="selected=!selected")
    .option_block
      .smallintro_for_space
        .name(@click="selected=!selected") {{ name }}
      .smallBlock(:class="{open: selected==true}")
        router-link.smallintroBlock(v-for="item in projectArray" :to="'/project/' + item.id" ) {{ item.title }}





  </template>

  <script>
  export default {
    data() {
      return {
        open: false,
        selected: false,
        showintroNav: [],
        projectArray: [

          {
            id: 4,
            title: '中小學師資生美感素養培力課程發展計畫',

          },
          {
            id: 5,
            title: '中小學在職教師暨行政人員美感素養提升計畫',
          },
          {
            id: 6,
            title: '美感教育出國計畫',
          },


          {
            id: 8,
            title: '幼兒園美感教育扎根計畫',
          },
          {
            id: 9,
            title: '跨領域美感教育卓越領航計畫 ',
          },
          {
            id: 10,
            title: '美感與設計課程創新計畫',
          },
          {
            id: 11,
            title: '樂器銀行',
          },
          {
            id: 12,
            title: '偏鄉藝術美感育苗計畫',
          },
          {
            id: 13,
            title: '好優Show學生藝團活動',
          },
          {
            id: 14,
            title: '廣達游於藝計畫',
          },
          {
            id: 15,
            title: '廣達設計學習計畫',
          },
          {
            id: 17,
            title: '驚嘆號-臺灣原住民族群永續教育計畫',
          },
          {
            id: 18,
            title: '文化美感輕旅行',
          },
          {
            id: 19,
            title: '藝起來尋美－教育部推動國民中小學辦理美感體驗教育計畫',
          },
          {
             id: 23,
             title: '大學推動藝術與美感素養導向先修課程計畫',
          },
          {
             id: 26,
             title: '藝師藝有-鼓勵學校延聘在地文化工作者或傳統藝師計畫',
          },


          {
            id: 21,
            title: '學美．美學－校園美感設計實踐計畫',
          },
          {
            id: 99,
            title: '見美．踐美．漸美－建構美感生活學習地圖之方案實踐實施計畫',
          },
          {
            id: 22,
            title: '校園美感環境再造計畫 ',
          },
          {
            id: 24,
            title: '境善．境美 - 學習環境美感涵養計畫 ',
          },
          {
            id: 1,
            title: '美感教育資源整合平台維護計畫',
          },
          {
            id: 2,
            title: '亞太地區美感教育研究室',
          },
          {
            id: 3,
            title: '團團有美感教學輔導網絡計畫',
          },
          {
            id: 98,
            title: '各級學校教育人員生活美感電子書發展計畫',
          },
          {
            id: 97,
            title: '《本土音樂教材編選指引II》—臺灣閩南語歌曲補充教材(國小中年級)',

          },


        ],
      }
    },
    watch: {
      '$route'(to, from) {
        this.selected=false
      },
    },
    computed: {
      //現在是哪個計畫
      name() {
        var t = this.$route.params.projectid
        return this.projectArray.filter(function(item) {return item.id==t})[0].title
      }
    }
  }
  </script>

  <style lang="sass">
  @import "@/assets/style.sass"

  .smallintroNav
    width: 100%
    min-height: 30px
    +flexcolumn
    box-sizing: border-box
    display: none
    // padding: 8px 0
    +phone
      display: flex
    .smallintro
      width: 100%
      height: 100%
      +flexrow
      justify-content: center
      align-items: center
      background-color: #EFEFEF
      padding: 5px 0

      .name
        width: 90%
        box-sizing: border-box
        color: #878787
        position: relative
        font-size: 17px
        line-height: 30px
      .intotri
        background: url('../../assets/tri.png')
        +bgcon
        background-position: center
        background-size: contain
        width: 20px
        height: 20px
        position: relative
        transform-origin: 50% 50%
        transition: 0.5s
        &.triopen
          transform: rotate(180deg)
          transition: 0.5s


    .smallBlock
      // transform: translateY(-100%)
      position: absolute
      transition: 0.3s
      visibility: hidden
      height: 0
      // max-height: 0

      &.open
        transition: 0.3s
        // transform: translateY(0)
        background-color: rgba(#333,0.8)
        +flexcolumn
        align-items: center
        +font
        z-index: 100
        width: 100%
        box-sizing: border-box
        visibility: visible
        height: auto
        padding: 15px

      .smallintroBlock
        text-decoration: none
        +c
        text-align: center
        margin-bottom: 10px
        font-size: 16px
        color: white
        line-height: 25px
  .smallintro_for_space
    position: absolute
    visibility: hidden
    min-height: 30px
  .option_block
    position: relative




  </style>



// WEBPACK FOOTER //
// src/views/Intro/SmallIntroNav.vue